export default "__VITE_ASSET__BAXwWngq__"